import { Component, ViewChild } from '@angular/core'
import { MatTable, MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router } from '@angular/router'
import { BehaviorSubject, Observable } from 'rxjs'
import { BuilderService } from '../builder-services/builder.service'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'
import { AppUsersService } from './services/app-users.service'
import { LoginService } from '../login/login.service'

export interface usersTableColumns {
  date: string
  time: any
  email: any
  user_id: string
  nickname: string
  first_name: string
  last_name: string
  email_verified: string
  role: string
  action: string
}
@Component({
  selector: 'app-app-users',
  templateUrl: './app-users.component.html',
  styleUrl: './app-users.component.scss'
})
export class AppUsersComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatTable)
  table!: MatTable<usersTableColumns>
  ELEMENT_DATA: usersTableColumns[] = []
  public dataSource: any = []
  public userColumns = ['nickname', 'email', 'date', 'email_verified', 'user_role', 'action']
  @ViewChild(MatSort, { static: true })
  matSort!: MatSort
  usersList: any = []
  searchText: string = ''
  statisticsData: any[] = []
  totalUsersCount$ = new BehaviorSubject<number>(0)
  projectUsers: any;
  public Math = Math;

  // Pagination
  pageSize = 5;
  pageIndex = 0;
  displayedUsers: usersTableColumns[] = [];
  constructor(
    private route: ActivatedRoute,
    public builderService: BuilderService,
    private router: Router,
    public loginService: LoginService,
    public AppUsersService: AppUsersService,
  ) {}

  ngOnInit(): void {
    this.dataSource = this.AppUsersService.usersDataSource;
    this.updateStatistics();
    this.AppUsersService.getUsersCount().subscribe((count: number) => {
      this.totalUsersCount$.next(count);
      this.updateStatistics();
    });
    this.getAllData()
  }

  getAllData = () => {
    this.builderService.showUpdateProgress = true
    let projectId = this.builderService.selectedProject
    this.AppUsersService.getUsers(projectId).subscribe((appUsers: any) => {
      this.AppUsersService.users = appUsers
      this.dataSource = this.AppUsersService.users
      this.updateStatistics();
      this.renderUsers(this.AppUsersService.users).subscribe((response: any) => {
        this.dataSource = new MatTableDataSource<usersTableColumns>(this.ELEMENT_DATA)
        this.dataSource.paginator = this.paginator
        this.dataSource.sort = this.matSort
        this.dataSource.sortingDataAccessor = (item: any, property: any) => {
          if (property === 'date') {
            // Convert the DD-MM-YYYY format back to a Date object
            const [day, month, year] = item.date.split('-');
            return new Date(`${year}-${month}-${day}`).getTime();
          }
          return item[property];
        };

        // Set initial sort to date descending
        this.dataSource.sort.active = 'date';
        this.dataSource.sort.direction = 'desc';
        this.table.renderRows()
      })
    })

    // Fetched separately (not merged into the displayed table) — used only by
    // deleteUser() to distinguish admin/staff accounts from storefront customers.
    this.AppUsersService.getUsersByProjectId(projectId).subscribe((projectUsers: any) => {
      this.projectUsers = projectUsers
    })
  }

  updateStatistics() {
    const users = this.AppUsersService.users || [];

    this.statisticsData = [
      { name: 'Total Users', value: this.totalUsersCount$.getValue() || users.length },
      { name: 'Total Verified Users', value: users.filter((u: any) => u.email_verified).length },
      { name: 'Total Non Verified Users', value: users.filter((u: any) => !u.email_verified).length }
    ];
  }

  convertDate = (dateString: string | null | undefined): string => {
    if (!dateString) {
      return "Invalid Date"; // Return a default value to avoid errors
    }
    
    const isoDate = dateString.split('T')[0]; // "2025-01-29"
  
    const parts = isoDate.split('-'); // ["2025", "01", "29"]
    
    if (parts.length !== 3) {
      return "Invalid Date"; // Handle unexpected formats
    }
  
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // "29-01-2025"
  };
  

  getRoleLabel(role: string): string {
    const roleMap: { [key: string]: string } = {
      admin: 'Admin',
      orderManager: 'Order Manager',
      productManager: 'Product Manager',
      stockManager: 'Stock Manager',
      customer: 'Customer',
      merchant: 'Merchant',
      vendor: 'Vendor',
      User: 'User'
    }
    
    return roleMap[role] || 'Unknown Role' // Return mapped role or fallback
  }

  renderUsers = (result: any) => {
    return new Observable<any>((observer) => {
      let usersList:any = Object.values(result);    
      for (const key in usersList) {
        // if(usersList[key].sub){
        if (Object.prototype.hasOwnProperty.call(usersList, key)) {
          const element = usersList[key];
          let nickname = element.nickname ||
          (element.firstName && element.lastName ? `${element.firstName} ${element.lastName}` :
          (element.first_name && element.last_name ? `${element.first_name} ${element.last_name}` :
          (element.displayName || 'Unknown')));
          const displayDate = element.updated_at 
                        ? this.convertDate(element.updated_at) 
                        : (element.registration_date || 'Unknown Date');              
          this.ELEMENT_DATA.push({
            email: element.email || element.emailAddress || '',
            user_id: element.sub || element.id || '',
            nickname: nickname,
            email_verified: element.email_verified !== undefined ? element.email_verified : false,
            date: displayDate,
            time: element.time || '1',
            role: element.selectedRole || element.user_role || element.role || element.type?.trim() || 'User',
            first_name: element.first_name || element.firstName || '',
            last_name: element.last_name || element.lastName || '',  
            action: ''
          })
          }
        // }
        }

        this.ELEMENT_DATA.sort((a, b) => {
          const [dayA, monthA, yearA] = a.date.split('-');
          const [dayB, monthB, yearB] = b.date.split('-');
          const dateA = new Date(`${yearA}-${monthA}-${dayA}`).getTime();
          const dateB = new Date(`${yearB}-${monthB}-${dayB}`).getTime();
          return dateB - dateA; // Descending order
        });
        this.AppUsersService.usersDataSource.data = this.ELEMENT_DATA;
        this.dataSource = this.AppUsersService.usersDataSource;
        this.pageIndex = 0;
        this.updateDisplayedUsers();
        setTimeout(() => {
          this.builderService.showUpdateProgress = false;
          observer.next();
          observer.complete();
        }, 100);
    });
      
  }

  ngAfterViewInit(): void {
    this.AppUsersService.usersDataSource.paginator = this.paginator;
    this.AppUsersService.usersDataSource.sort = this.matSort;
  }

  editUser = (id: string) => {
    this.router.navigate([`/users/${id}`], { relativeTo: this.route })
  }

  /**
   * Deletes a user after confirming the action with the user.
   * @param user_id - The unique identifier of the user to be deleted.
   * @param user_name - The name of the user to be deleted, used in the confirmation message.
   * @returns void
   */
  deleteUser = (user_id: string, user_name: string) => {
    const adminUser = (this.projectUsers || []).some((user:any) => user.id == user_id)
    if (confirm('Are you sure to delete user ' + user_name + ' ? This step is unrecoverable')) {
   if (adminUser){
     this.AppUsersService.deleteStacksUser(user_id).subscribe(response => {
      alert('User deleted successfully')
      this.getAllData()
     })

   } else{

         this.AppUsersService.removeUser(user_id).subscribe((response: any) => {
          alert('User deleted successfully')
          this.getAllData()
          })
       } 
     
      }
    }
  /** Updates displayed users based on current page */
  updateDisplayedUsers(): void {
    const data = this.dataSource?.filteredData || this.dataSource?.data || []
    const startIndex = this.pageIndex * this.pageSize
    const endIndex = startIndex + this.pageSize
    this.displayedUsers = data.slice(startIndex, endIndex)
  }

  /** Pagination navigation */
  previousPage(): void {
    if (this.pageIndex > 0) {
      this.pageIndex--
      this.updateDisplayedUsers()
    }
  }

  nextPage(): void {
    const totalPages = this.getTotalPages()
    if (this.pageIndex < totalPages - 1) {
      this.pageIndex++
      this.updateDisplayedUsers()
    }
  }

  getTotalPages(): number {
    const data = this.dataSource?.filteredData || this.dataSource?.data || []
    return Math.ceil(data.length / this.pageSize) || 1
  }

  changePageSize(size: number): void {
    this.pageSize = Number(size)
    this.pageIndex = 0
    this.updateDisplayedUsers()
  }

  /**
   * Applies a filter to the data source of the user table.
   * The filter is applied to the name, email, and date columns of the table.
   * The filter value is taken from the `searchText` property, which is trimmed and converted to lowercase.
   */
  applyFilter() {
    const filterValue = this.searchText ? this.searchText.trim().toLowerCase() : ''

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return data.nickname?.toLowerCase().includes(filter) || data.email?.toLowerCase().includes(filter) || data.date.includes(filter)
    }

    this.dataSource.filter = filterValue
    this.pageIndex = 0
    this.updateDisplayedUsers()
  }
}
